import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import LoginPage from '@/views/LoginPage.vue'
import SignupPage from '@/views/SignupPage.vue'
import Store from '@/views/Store.vue'
import ProductPage from '@/views/ProductPage.vue'
import CartPage from '@/views/CartPage.vue'
import LoginLess from '@/views/Loginless.vue'
import Checkout from '@/views/Checkout.vue'
import MyOrders from '@/views/MyOrders.vue'
import CheckoutConfirm from '@/views/CheckoutConfirm.vue'
import AddDetails from '@/views/AddDetails.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/:store_slug/login',
    name: 'Login',
    component: LoginPage
  },
  {
    path: '/:store_slug/checkout_wo/',
    name: 'LoginLess',
    component: LoginLess
  },
  {
    path: '/:store_slug/signup',
    name: 'SignupPage',
    component: SignupPage
  },
  {
    path: '/:store_slug',
    name: 'Store',
    component: Store
  },
  {
    path: '/:store_slug/product/:product_id',
    name: 'Product',
    component: ProductPage
  },
  {
    path:'/:store_slug/cart',
    name:'Cart',
    component: CartPage
  },
  {
    path:'/:store_slug/checkout/',
    name:'Checkout',
    component: Checkout,
    props: (route) => ({
        orderData : route.params.orderData
    })
  },
  {
    path:'/:store_slug/my-orders',
    name:'MyOrders',
    component: MyOrders
  },
  {
    path:'/:store_slug/addDetails',
    name:'AddDetails',
    component: AddDetails
  },
  {
    path:'/:store_slug/checkout/confirm',
    name:'CheckoutConfirm',
    component: CheckoutConfirm
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
